<!--
  FlexSidebar — contextual sidebar for the "Flex" cauldron (flexibility-
  market dashboards: day-ahead / intraday / imbalance / aFRR / mFRR /
  FCR / capture price / cross-border / balancing). One row per domain
  dashboard, deep-linked to `/reports/flexibility/<id>`. Rows are
  sourced from `src/dashboards/metadata.js` so adding a new flex
  dashboard there extends this sidebar automatically.
-->
<template>
  <div class="flex flex-col h-full">
    <nav class="flex-1 overflow-y-auto px-3 py-3" aria-label="Flex markets navigation">
      <div v-if="!collapsed" class="sidebar-section-label">
        {{ t('cauldron.flex.label') }}
      </div>

      <sidebar-menu-item
        v-for="dash in flexDashboards"
        :key="dash.id"
        :to="dash.route"
        :label="t(dash.title)"
        :icon="dash.icon"
        :collapsed="collapsed"
        active-match="prefix"
        @click="emit('navigate')"
      />
    </nav>
  </div>
</template>

<script setup>
  /* eslint-disable no-undef */
  import SidebarMenuItem from '@/components/navigation/SidebarMenuItem.vue';
  import { flexDashboards } from '@/features/visualizations/domain/metadata';
  import { useI18n } from 'vue-i18n';

  defineProps({
    collapsed: { type: Boolean, default: false },
  });
  const emit = defineEmits(['navigate']);

  const { t } = useI18n();
</script>
